import { render, staticRenderFns } from "./Honors.vue?vue&type=template&id=6eeefdba&scoped=true"
import script from "./Honors.vue?vue&type=script&lang=js"
export * from "./Honors.vue?vue&type=script&lang=js"
import style0 from "./Honors.vue?vue&type=style&index=0&id=6eeefdba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeefdba",
  null
  
)

export default component.exports